import {createEvent} from "effector";

export const openViewModalEv = createEvent()
export const closeViewModalEv = createEvent()

export const sendTicketEv = createEvent()
